import {
    ADD_EVENT_DETAIL,
    CREATE_EVENT_ACTION,
    RESET_EVENT_DETAIL
} from '../types';
// We will put the initial states in the state variables:
const initialState = {
    data: {
        name: '',
        type: '',
        guestsNumber: '',
        startDate: '',
        endDate: '',
        invitationTemplate: '',
        guestList: [],
        qrCodeImageDimensions: {
            width: '',
            height: '',
            xAxis: '',
            yAxis: ''
        },
        details: {
            brideFullname: '',
            groomFullname: '',
            hostFullname: '',
            story: ''
        },
        eventStoryImage: [],
        location: {
            city: '',
            country: '',
        },
        centeringFactor: 0,
        formData: undefined
    }
};

export const createEventReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_EVENT_ACTION:
            return {
                ...state,
                data: action.payload,
            };
        case ADD_EVENT_DETAIL:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload
                }
            };
        case RESET_EVENT_DETAIL:
            return {
                ...state,
                data: initialState
            };
        default:
            return state;
    }
};
